export const getMfeName = (context) => {
    if (typeof context.mfe === 'string') {
        return context.mfe;
    }
    return 'unknown';
};
export const getMfeVersion = (mfe) => {
    if (!window.__app_config?.WEBUI_MFE_VERSIONS) {
        return undefined;
    }
    const version = window.__app_config.WEBUI_MFE_VERSIONS[mfe];
    if (!version) {
        return undefined;
    }
    return version;
};
export const setMfeVersion = (mfe, version) => {
    if (!window.__app_config?.WEBUI_MFE_VERSIONS) {
        window.__app_config.WEBUI_MFE_VERSIONS = {};
        window.__app_config.WEBUI_MFE_VERSIONS[mfe] = version;
        return;
    }
    const isVersionAlreadySet = window.__app_config.WEBUI_MFE_VERSIONS[mfe] === version;
    if (isVersionAlreadySet) {
        return;
    }
    window.__app_config.WEBUI_MFE_VERSIONS[mfe] = version;
};
